import { Component, Prop } from 'vue-property-decorator';
import BaseBlock from '@/blocks/base-block';
import { Block } from '../../../helpers/components';
import { ApartmentDTO } from '../../../model/ApartmentDTO';
import { FloorAbbrForTooltip } from '../../../enums/FloorAbbrForTooltip'
import Gallery from '@/components/gallery/gallery';
import { apartmentHeadingData } from './apartment-heading.data';
import { ImageResourceDTO } from '@/model/ImageResourceDTO';
import { ApartmentDetailHeadingTitle } from '../../../components/apartment-detail-heading-title/apartment-detail-heading-title';


@Block(apartmentHeadingData)
@Component({
	components: {
		Gallery,
		ApartmentDetailHeadingTitle
	}
})
class ApartmentHeadingBlock extends BaseBlock {
	@Prop() apartment: ApartmentDTO;
	@Prop() gallery: ImageResourceDTO[][];

	reactive: boolean = true;	// to make isFavorite reactive at least to a change to this variable

	get city() {
		var result = this.apartment.location.city;
		if (this.apartment.location.cityPart) {
			result += " - " + this.apartment.location.cityPart;
		}

		return result;
	}

	get showBreadcrumbs() {
		return !(this.$route.query.predbezne && this.$route.query.csh);
	}

	get galleryHeight() {
		const mql = window.matchMedia("(min-width: 768px)");
		return mql.matches ? 620 : 500
	}


	//get bannerHtml() {
	//	return this.getText('banner').trim();
	//}

	showTooltipFloor(floorAbbr: string) {
		return (<any>Object).values(FloorAbbrForTooltip).includes(floorAbbr);
	}

	isFavorite(reactive: boolean) {
		return this.$cookiesService.getFavoriteProducts().includes(this.apartment.catalogNumber);
	}

	toggleFavorite(catalogNumber: string, to: boolean) {
		this.$cookiesService.setFavoriteProducts(to ? this.$cookiesService.getFavoriteProducts().concat(catalogNumber) : this.$cookiesService.getFavoriteProducts().filter(p => p != catalogNumber));
		this.reactive = !this.reactive;
	}
}

export default ApartmentHeadingBlock;
